<template>
<div>
<div class="card border  border-primary">
<div class="card-header text-white bg-primary">
            
            <h4 v-if="type=='A'" ><i style="color:#FFCC00" class="fas fa-search mr-3 " aria-hidden="true"></i>RICERCA CLIENTE</h4>
            
            <span v-else-if="type=='B'" ><i style="color:#FFCC00" class="fas fa-user-plus mr-3 " aria-hidden="true"></i>{{customerId > 0 ? 'MODIFICA CLIENTE':'NUOVO CLIENTE'}}
            </span>
            <span v-else-if="type=='C'" ><i style="color:#FFCC00" class="fas fa-shopping-cart mr-3 " aria-hidden="true"></i>VENDITE E PAGAMENTI
            </span>
            <span v-else-if="type=='D'" ><i style="color:yellow" class="fas fa-vote-yea mr-3" aria-hidden="true"></i>REGISTRA PAGAMENTO
            
            </span>
            <span v-else-if="type=='E'" ><i  class="fas fa-print mr-3" aria-hidden="true"></i>STAMPA RICEVUTA</span>
            <span v-else-if="type=='F'" ><i  class="fas fa-cart-plus mr-3" aria-hidden="true"></i>SHOPPING LIST CLIENTE</span>
            <span v-else-if="type=='G'" ><i  class="fas fa-edit mr-3" aria-hidden="true"></i>MODIFICA CASHBACK CLIENTE</span>
          
          </div>

    
          <div style="color:black" class="card-body"> 

            <div v-if="type=='A'">  
             

            <form name="customerSearch" v-on:submit.prevent="getData()">
                            
              <div class="row">
              <div class="col input-group">
                <div class="input-group-prepend">
                <div class="input-group-text">COGNOME</div>
                </div>
                <input id="custId" ref="last_name_search" required v-focus autocomplete="off" type="text" class="form-control" placeholder="Lunghezza cognome minimo 4 caratteri." v-model="cust.last_name">
              </div>
              <div class="col input-group">
                <div class="input-group-prepend">
                <div class="input-group-text">NOME</div>
                </div>
                <input id="cust_name" v-model="cust.first_name" type="text" class="form-control" placeholder="nome">
              </div>
              <div class="col">
              <button :disabled="bt_spinner" class="btn btn-primary ">
                <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
                CERCA
                <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2 " role="status" aria-hidden="true"></span>
              </button>
              </div>
            
              </div>
            </form>


              <div class="_row btn_space mt-3 ">
                          
                <button :disabled="bt_spinner"  @click="swapDiv('B')"  type="button" class="btn btn-success  mb-2 mr-2">
                  <i class="fas fa-user-plus mr-2" aria-hidden="true"></i>
                  NUOVO
                </button>


                
                  <button :disabled = "export_spinner || bt_spinner" @click="export_data()"  type="button" class="btn btn_export mb-2  float-right">
                  <i class="fas fa-file-export mr-2" aria-hidden="true"></i>                  
                  {{!export_spinner ? 'ESPORTA TUTTI I CLIENTI':'Export in corso ...'}}   
                   <span v-if="export_spinner"  class="spinner-border spinner-border-sm ml-2 " role="status" aria-hidden="true"></span>
                  </button> 

                  <button :disabled="bt_spinner"  @click="getCustomerListNegativeBalance()"  type="button" class="btn btn-warning mb-2  float-right_">
                  <i class="fas fa-user-minus mr-2" aria-hidden="true"></i>
                  CLIENTI CON SALDO NEGATIVO
                  <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2 " role="status" aria-hidden="true"></span>
                  </button>

       
                  
              </div>
            
            <alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
            <div class="table-wrapper-scroll-y my-custom-scrollbar">
              <table class="table table-sm table-hover table-striped mb-0">
                <thead>
                  <tr class="table-primary_">
                    <!--
                    <th scope="col"></th> 
                    
                    <th scope="col"></th> 
                    <th scope="col"></th> 
                    <th scope="col"></th> 
                    <th scope="col"></th> 
                    -->
                    <th scope="col"></th> 
                    
                    <th scope="col">COGNOME CLIENTE</th>
                    <th scope="col">NOME CLIENTE</th>
                    <th scope="col">TELEFONO</th>
                    <th scope="col">MAIL</th>
                    <th scope="col">G</th>
                    <th scope="col">M</th>
                    <th scope="col">ANNO</th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr data-toggle="tooltip" title="Doppio click seleziona cliente" class="pointer" @dblclick="setCustomer(item)" v-for="(item, index) in items" :key="index">
                    <td>

                    <div class="dropdown">
                      <button  style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                          <i class="fas fa-list mr-2" aria-hidden="true"></i>
                          OPZIONI
                      </button>
                      <div class="dropdown-menu ">
                        
                        <a data-toggle="tooltip" title="MODIFICA ANAGRAFICA CLIENTE"  class="dropdown-item" @click="editRow(index)" href="#">
                        <i style="color : royalblue" class="fas fa-edit mr-2" aria-hidden="true"></i>
                          MODIFICA ANAGRAFICA
                        </a>
                        <a  data-toggle="tooltip" title="VENDITE E PAGAMENTI CLIENTE"  class="dropdown-item" @click="getSales(index)" href="#">
                        <i style="color : orange" class="fas fa-shopping-cart mr-2" aria-hidden="true"></i>
                          VENDITE E PAGAMENTI
                        </a>
                        <a  data-toggle="tooltip" title="SHOPPING LIST CLIENTE"  class="dropdown-item" @click="getShoppingItems(index)" href="#">
                          <i style="color : #336600  " class="fas fa-shopping-cart mr-2" aria-hidden="true"></i>
                          SHOPPING LIST
                        </a>

                        <a v-if="company.Id == 49" data-toggle="tooltip" title="FIDELITY CARD"  class="dropdown-item" @click="setFidelityCard(index)" href="#">
                          <i style="color : red  " class="far fa-id-card mr-2" aria-hidden="true"></i>
                        FIDELITY CARD
                        </a>
                        
                        
                        <div class="dropdown-divider">

                          
                        </div>
                        <h6 class="dropdown-header">CASHBACK</h6>
                        <a data-toggle="tooltip" title="MODIFICA CASHBACK DEL CLIENTE" v-if="custGroupId==0"   class="dropdown-item" @click="updateCashBack(item)" href="#">
                          <i style="color : brown " class="fas fa-edit mr-2" aria-hidden="true"></i>
                          MODIFICA 
                        </a>
                    


                        <a data-toggle="tooltip" title="STAMPA RICEVUTA CASHBACK " v-if="custGroupId==0"    class="dropdown-item" @click="printCashBack(item.customerId)" href="#">
                          <i style="color : green" class="fas fa-print mr-2" aria-hidden="true"></i>
                            STAMPA ULTIME 5 OPERAZIONI
                        </a>
                        <a data-toggle="tooltip" title="STAMPA TUTTE LE OPERAZIONI" v-if="custGroupId==0"    class="dropdown-item" @click="printCCB_PDF(item.customerId)" href="#">
                          <i style="color : rgb(128, 0, 41)" class="far fa-file-pdf mr-2" aria-hidden="true"></i>
                            STAMPA TUTTE LE OPERAZIONI
                        </a>
                      
                      
                    </div>
            </div>
                    </td>
                    <!--
                    <td><a @click="editRow(index)"><i style = 'color : #822222' data-toggle="tooltip" title="MODIFICA ANAGRAFICA"  class="fa fa-edit" aria-hidden="true"></i></a></td>
                    <td><a @click="getSales(index)"><i style = 'color : orange' data-toggle="tooltip" title="VENDITE E PAGAMENTI"  class="fas fa-shopping-cart" aria-hidden="true"></i></a></td>
                    <td><a @click="getShoppingItems(index)"><i style='color:#336600' data-toggle="tooltip" title="SHOPPING LIST"  class="fas fa-cart-plus" aria-hidden="true"></i></a></td>
                    <td><a @click="updateCashBack(item)"><i style='color:#336600' data-toggle="tooltip" title="MODIFICA CASHBACK"  class="fas fa-edit" aria-hidden="true"></i></a></td>
                    <td><a @click="printCashBack(item.customerId)"><i style='color:#336600' data-toggle="tooltip" title="MODIFICA CASHBACK"  class="fas fa-edit" aria-hidden="true"></i></a></td>
                    -->
                    <td>{{item.last_name}}</td>
                    <td>{{item.first_name}}</td>  
                    <td>{{item.mobile}}</td>
                    <td>{{item.email}}</td>
                    <td>{{item.day_of_birth}}</td>
                    <td>{{item.month_of_birth}}</td>
                    <td>{{item.year_of_birth}}</td>

                  </tr> 
                </tbody>
              </table>
            </div>
          
     
            <!-- LISTA CLIENTI -->
            </div>

            <div v-else-if="type==='B'">

                 
                <button @click="swapDiv('A')"  type="button" class="btn btn-secondary btn-block mb-2 mr-2">
                    <i style="color:yellow" class="fa fa-reply icon mr-2" aria-hidden="true"></i>
                   RITORNA A RICERCA CLIENTE
                </button>  
                  
                  <ul class="nav nav-tabs" id="myTab1" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button @click="setTab('anagrafica')" class="nav-link active" id="home-tab" data-toggle="tab" data-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">ANAGRAFICA</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button @click="setTab('billing')" class="nav-link" id="profile-tab" data-toggle="tab" data-target="#profile1" type="button" role="tab" aria-controls="profile" aria-selected="false">FATTURAZIONE</button>
                    </li>
                    <li v-if="company.Id == 1" class="nav-item" role="presentation">
                      <button @click="setTab('sapiaClub')" class="nav-link" id="profile-tab" data-toggle="tab" data-target="#profile2" type="button" role="tab" aria-controls="profile" aria-selected="false">SAPIA CLUB</button>
                    </li>
                  </ul>
                




  <div v-if="component=='anagrafica'">
    
    
    <form   v-on:submit.prevent="saveData()">
    <div class="form-row mt-4"> 
    <div class="form-group col-md-4">
      <label for="input_surname"><strong>COGNOME</strong></label>
      <input v-focus ref="inputNewLastName" required type="text" class="form-control" id="input_last" v-model="cust.last_name">
    </div>
    <div class="form-group col-md-4">
      <label for="input_name"><strong>NOME</strong></label>
      <input required type="text" class="form-control" id="input_first" v-model="cust.first_name">
    </div>
    <div class="form-group col-md-4">
      <label for="input_tel"><strong>TELEFONO</strong></label>
      <input required type="text" class="form-control" id="input_tel" placeholder="" v-model="cust.mobile">
    </div>

    </div>
<div class="form-row">
  <div class="form-group col-md-6">
  <label for="input_tel">Mail</label>
  <input type="text" class="form-control" id="input_mail" placeholder="" v-model="cust.mail">
</div> 
  

 <div v-if="1==0" class="form-group col-md-6">
  <label for="input_name">Partita iva/codice fiscale</label>
  <input type="text" class="form-control" id="input_cf" v-model="cust.fc">
 </div>                  

</div>
<div class="form-row">
<div class="form-group col-md-6">
  <label for="input_address">Indirizzo</label>
  <input type="text" class="form-control" id="input_address" placeholder="" v-model="cust.address">
</div>
<div class="form-group col-md-4">
  <label for="input_city">Città</label>
  <input type="text" class="form-control" id="input_city" v-model="cust.city">
</div>
<div class="form-group col-md-2">
  <label for="input_zip">Cap</label>
  <input type="text" class="form-control" id="input_zip" v-model="cust.zip_code">
</div>
</div>
<div class="row">
  <div class="col">
    <div class="form-group">
      <label  for="input_data">Giorno di nascita</label>
      <select class="form-control" id="day" v-model="cust.day_of_birth">
        <option :value="n" v-for="n in 31" :key="n">{{n}}</option>
      </select>
    </div>
  </div>
  <div class="col">
    <div class="form-group">
      <label for="input_data">Mese di nascita</label>
      <select class="form-control" id="month" v-model="cust.month_of_birth">
        <option :value="n" v-for="n in 12" :key="n">{{n}}</option>
      </select>
    </div>
  </div>
  <div class="col">
    <div class="form-group">
      <label for="input_data">Anno di nascita</label>
      <select class="form-control" id="year" v-model="cust.year_of_birth">
        <option :value="year" v-for="year in years" :key="year">{{year}}</option>
      </select>
    </div>
  </div>
</div>

<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

                              
<button  :disabled="bt_spinner" class="btn btn-primary mt-3">
  <i  style="color:#FFCC00" class="fas fa-save mr-3" aria-hidden="true"></i>
  
  REGISTRA
  <span v-if="bt_spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>
<button :disabled="update == true" @click="joinToCart()"  type="button" class="btn btn-info border border-primary  ml-4 mt-3">
  <i style="color:yellow" class="fas fa-shopping-cart mr-2" aria-hidden="true"></i>
 ASSOCIA ALLA VENDITA
</button>  

</form>
</div>


<billing v-if="component=='billing'"  v-bind:customerId="customerId"></billing>
<sapiaClub v-if="component=='sapiaClub'"  v-bind:customerId="customerId" ></sapiaClub>


</div>

            
            <!-- FIDELITY CARD -->
            <div v-else-if="type==='H'">
              <fidelityCard v-bind:customer="fidelityCard" ></fidelityCard>
            </div>


            <!-- LISTA VENDITE -->  
            <div v-else-if="type==='C'">
              <button @click="swapDiv('A')"  type="button" class="btn btn-secondary mb-5">
                    <i style="color:yellow" class="fa fa-reply mr-2" aria-hidden="true"></i>
                   RITORNA A RICERCA CLIENTE
              </button>
              <div class="row">

                
                <div class="col">  
                  <balance v-bind:customerId='customerId' :key = "componentKey" />
                </div>
                <div class="col">

                 

                  <div class="btn-group-vertical float-right">                  

                  <button @click="swapDiv('D')"  type="button" class="btn btn-success  text-nowrap">
                    <i  class="fas fa-vote-yea mr-2" aria-hidden="true"></i>
                    REGISTRA PAGAMENTO
                  </button>

                  <button style="background-color:#FF6600"   type="button" class="btn text-nowrap mt-2 mb-2"
                  data-toggle="collapse" data-target="#collapseReset" aria-expanded="false" aria-controls="collapseReset"
                  >
                    <i  class="fas fa-eraser mr-3" aria-hidden="true"></i>
                    RESET SALDO
                  </button>
                  <div class="collapse text-center" id="collapseReset">
                      <div class="row mb-2">
                        <div class="col">  
                        <small style="color:#FF6600" class="text-nowrap label"><strong>PROCEDO AL RESET ? </strong></small>
                        </div>
                        
                        
                         <div class="col">   
                        <button @click="resetBalance()" type="button" class="btn btn-outline-primary btn-sm label">SI</button>
                         </div>
                         <div class="col">  
                        <button type="button" data-toggle="collapse" data-target="#collapseReset" class="btn btn-outline-secondary btn-sm label">NO</button>
                        
                        </div>
                      </div>
                  </div>
                   
                    <alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

                  </div>
                  

                </div>
              </div>  
              
              <component v-on:openPDF="openPDF($event)" v-bind:customerId='customerId' v-bind:is="component2" />   
              
            </div>

            <!-- PAYMENT -->
            <div v-else-if="type==='D'">

              <button @click="swapDiv('C')"  type="button" class="btn btn-secondary mb-5">
                    <i style="color:yellow" class="fa fa-reply mr-2" aria-hidden="true"></i>
                  RITORNA A VENDITE E PAGAMENTI
              </button>

              <div class="row mb-5">
                <div class="col">  
                  <component  v-bind:customerId='customerId' v-bind:is="component1" />
                </div>
              </div>  
              <component @close="component1 = '',swapDiv('C')" v-bind:customerId='customerId' v-bind:is="component2" />   
            </div>

            <div v-else-if="type==='E'">
              <iframe :src="pdf" width="100%" height="500" style="margin-bottom:0px"></iframe>
            </div>
            <div v-else-if="type=='F'">
               <button @click="swapDiv('A')" type="button" class="btn btn-secondary mb-1 mr-1">
                    <i style="color:yellow" class="fa fa-reply mr-2" aria-hidden="true"></i>
                  RITORNA A RICERCA CLIENTE</button> 
                   <h4 style = "color:#336600" class="mt-3 mb-1">CLIENTE 
                    <span> <strong>{{cust.last_name}} {{cust.first_name}} </strong></span></h4>
                  <component  v-bind:customerId='customerId' v-bind:is="component3" />
            </div>  
            <div v-else-if="type=='G'">
               <button @click="swapDiv('A')" type="button" class="btn btn-secondary mb-1">
                    <i style="color:yellow" class="fa fa-reply icon mr-2" aria-hidden="true"></i>
                   RITORNA A RICERCA CLIENTE</button> 
                  
                   <updateCB v-bind:props="cb"></updateCB> 
                  
            </div>  
            

            <!-- CARD BODY -->
            </div>

            <!-- CARD  -->
            </div>



        
      <!--  
      <div class="modal-footer">
         
        <button @click="type='A',items=[],msg.title='',closeForm()" type="button" class="btn btn-secondary">CHIUDI</button>
      </div>
    -->

    
  





</div>



</template>

<script>

import api               from '@/api'
import { mapGetters }    from 'vuex';
import spinner           from '@/components/common/Spinner.vue';
import alertBox          from '@/components/common/AlertBox.vue';
import sales             from '@/components/frontOffice/customer/CustomerSales.vue'
import payment           from '@/components/frontOffice/customer/CustomerPayment.vue'
import balance           from '@/components/frontOffice/customer/CustomerBalance.vue'
import shoppingList      from '@/components/frontOffice/customer/CustomerShoppingList.vue'
import updateCB          from '@/components/frontOffice/customer/UpdateCustomerCashback.vue'
import fmt               from '@/components/mixins/fmt.js'
import receiptHF         from '@/components/mixins/ReceiptHeading.js'
import printCCB          from '@/components/mixins/CustomerCashBackHistory.js'
import printCCB_PDF      from '@/components/mixins/CustomerCashBackPDF.js'
import billing           from '@/components/frontOffice/customer/CustomerBilling.vue'
import sapiaClub         from '@/components/frontOffice/customer/CustomerSapiaClub.vue'
// import axios             from 'axios'
import fidelityCard      from '@/components/frontOffice/customer/FidelityCard.vue'




export default {
  //props : ['form'],
  mixins: [fmt,receiptHF,printCCB,printCCB_PDF], 
  components: {spinner,alertBox,sales,payment,balance,shoppingList,updateCB,billing,sapiaClub,fidelityCard},
  data() {
    return {
     
      fidelityCard           : {},
      type                   : 'A',
     
      items                  : [],
      spinner                : false,

     
      balance                : 0,
      years                  : [],
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
      
      bt_spinner             : false,
      customerId             : 0,
      //customer               : '',
      
      
      
      
      
      pdf                    : '',
      export_spinner         : false,
      cust                   : {},
      cb                     : {},
      deskId                 : '',
      update                 : true,
     
      component              : 'anagrafica',
      
      
         
    };
  },
  computed :{
   
   ...mapGetters(['company','custGroupId','storeId']),
 
   
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {                
        el.focus();
      }
    }
  },
  mounted: function() {

    let deskId = JSON.parse(localStorage.getItem("deskId"))
    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
 
   console.log('Customer Group ID',this.custGroupId)

   },
  created: function() {
    
    var start = 1920
    var d = new Date();
    var end = d.getFullYear();
    
    var i = 0
    for (i = end; i >= start; i--) {
        this.years.push(i)
    }


 


    
  },
  methods: 
  { 

setFidelityCard(index)
{
  this.fidelityCard = {...this.items[index]}

  this.type = 'H'
},

 async getValidSapiaClub(customerId)
      {
        this.msg.title = ''
        let customer = {"customerId" : customerId}
        let sp       = {'sp' : 'spValidSapiaClub'}
        let json     = Object.assign(customer, sp);
        
        return new Promise( async (resolve) =>  {

        await api.post(json).then(res => {
          
          if(res.status==200)
            {
                
                resolve({"stato" : res.data.recordsets[0][0].Stato})

            }
           else if(res.status==500)
           {
                
              resolve({"stato" : 'Scaduto'})
                                
                    
           } 
           else
            {
                
                resolve({"stato" : 'Scaduto'})
              
              
              
                 
            } 
          

          }).catch(err => {
              
              
              
              resolve({"stato" : 'Scaduto'})

              
              
          }).finally(() => {
          
        });

        })

      },



  setTab(component)  
  {
    
    this.component = component
        
  },  
  joinToCart()
  {
    this.cust.customerId = this.customerId
    this.cust.balance = 0
    this.cust.cashback = 0
    
    this.setCustomer(this.cust)
    
  },
  async   getCustomerListNegativeBalance()
    {
      this.bt_spinner = true
      const sp   = {'sp'       : 'spCustomerListNegativeBalance'}
      const data = {'companyId':this.company.Id,'custGroupId':this.custGroupId}
      
      //console.log(data)

      const json  = Object.assign(data, sp);
      
      
      
      await api.post(json).then(res => {
       
        if(res.status==200)
          {
            this.items   = res.data.recordsets[0]
            
            if(this.items.length==0)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = 'CLIENTI CON SALDO NEGATIVO INESISTENTI.'
              this.msg.type = 1
           
            }         
          }
          else if(res.status==500)
          {
           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1

          } 
          else
          {
           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
          } 
      }).catch(err => 
      {
       
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
          
      }).finally(() => {
        this.bt_spinner = false
      });

      
    },
    async printCashBack(customerId)
    {
      const receiptText = await this.getReceiptHeading(this.storeId,this.deskId)
      const data = await this.getCBData(customerId)
      

      if(data[0].length>0)
      {
        this.printCashBackHistory(receiptText,data)
      }

    },

    updateCashBack(cust)
    {
      this.cb.first_name = cust.first_name
      this.cb.last_name = cust.last_name
      this.cb.cashback  = cust.cashback
      this.cb.customerId = cust.customerId
      this.type = 'G'
    },

    
        

    async resetBalance()
    {
      
     
      this.msg.title = ''
      this.spinner = true
      var sp   = {'sp'         : 'spResetCustomerBalance'}
      var data = {'customerId' : this.customerId}
      var json  = Object.assign(data, sp);

      await api.post(json).then(res => {
          if(res.status==200)
            {
               $('#collapseReset').collapse('hide')
              this.componentKey++
              this.msg.title = 'RESET SALDO EFFETTUATO.'
              this.msg.body = ''
              this.msg.type = 0         
            }
            else if(res.status==500)
            {
             
              this.msg.title = 'ATTENZIONE '
              this.msg.type = 1
              this.msg.body = res.data
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1               
            } 
        }).catch(err => 
        {
          
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1                 
        }).finally(() => {
          this.spinner = false
        });
      
    },
    openPDF(pdf)
    {
      this.type = 'E'
      this.pdf = pdf
    },

    

    getShoppingItems(index)
    {

      this.customerId        = this.items[index]['customerId']
      this.cust.last_name    = this.items[index]['last_name']
      this.cust.first_name   = this.items[index]['first_name']
      this.component3        = 'shoppingList'
      this.type              = 'F'
    },
    getSales(index)
    {

      this.customerId = this.items[index]['customerId']
      
      
      this.component2  = 'sales'
      this.component1  = 'balance'
      
      this.type       = 'C'

    },
    /*
    closeForm()
    { 
      
      if(this.customerCheck )
      {
        this.cust.customerId = this.customerId
        this.cust.balance    = this.balance
        this.cust.cashback   = 0
        
        
        this.setCustomer(this.cust)
        this.customerCheck = false
      }
      else
      {
        var obj = {}

        this.$emit('close',obj)
        this.reset()
      }
    },
  */
    editRow(index)
    {
      
      this.update         = true
      this.customerId     = this.items[index].customerId,
      this.cust           = this.items[index]

      this.type = 'B'
      this.$nextTick(() => {
           
           //$('#input_last').trigger('focus');
      })
      
    },
    
    reset()
    {
      this.customerId     = 0      
      this.cust           = {}
      this.update         = true
     
      
   
    },
    
    swapDiv(type)
    {
    
      this.msg.title = ''

      if(type == 'B')
      {
        //this.saveBtn = false
        this.type = 'B'
        
        this.reset()
        this.$nextTick(() => {
           
           //this.reset()
           
           this.$refs.inputNewLastName.focus()
           
          })

       
      }
      if(type=='C')
      {
        
        
        this.component2  = 'sales'
        this.componentKey  ++
        this.type = type
      }
      if(type == 'A')
      {
        this.type = 'A'
        //this.saveBtn = false
        this.component = 'anagrafica'
        this.$nextTick(() => {
      
  
          this.$refs.last_name_search.focus()  
        
        
        })
         
         
      }
      if(type == 'D')
      {
        this.type        = type
        this.component1  = 'balance'
        this.component2  = 'payment'
      
      }

    },

    async saveData()
    {
      
      this.bt_spinner = true
      const sp   = {'sp'    :  this.customerId == 0 ? 'spCreateCustomer' :'spUpdateCustomer'}      
      const data = {
                  'customerId'     : this.customerId, 
                  'companyId'      : this.company.Id,
                  'custGroupId'    : this.custGroupId
                 }
                
      const json  = Object.assign(data, sp,this.cust)
      
      
      await api.post(json).then(async res  => {
        if(res.status==200)
          {
            if(this.customerId == 0)
              {
                this.customerId =  res.data.recordsets[0][0].customerId

                this.update = false

               
                                
              }


              
            if(this.customerId == -1)
              {
                this.customerId = 0
                this.msg.title  = 'ATTENZIONE '
                this.msg.body   = 'CLIENTE CON QUESTO NUMERO DI TELEFONO GIA\' REGISTRATO.'
                this.msg.type   = 1
          
              }
              else
              {
               
                this.msg.title  = 'CLIENTE REGISTRATO.'
                this.msg.body   = ''
                this.msg.type   = 0
      
            
              }      
          }
          else if(res.status==500)
          {
          

            this.msg.title  = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type   = 1

          } 
          else
          {
            

            this.msg.title  = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type   = 1               
          } 
      }).catch(err => 
      {
        console.log(err.message)   
            this.msg.title  = err.message
            this.msg.type   = 1 
      }).finally(() => {
        this.bt_spinner = false
      });

    
    },

    async getData()
    {
      
      this.items = []

      this.msg.title = ''
      if(this.cust.last_name.length < 4)
      {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = 'Compilare il cognome/denominazione cliente con almeno 4 caratteri'
          this.msg.type = 1
    
          return
      }
      let first_name = '%'
      if(this.cust.first_name)
      {
        first_name = '%' +  this.cust.first_name + '%'
      }
      

      this.bt_spinner = true
      const sp   = {'sp'       : 'spCustomerList'}
      const data = {'customer' : this.cust.last_name,'first_name' : first_name, 'companyId':this.company.Id,'custGroupId':this.custGroupId}
      
      //console.log(data)

      const json  = Object.assign(data, sp);
            
      await api.post(json).then(res => {
       
        if(res.status==200)
          {
            this.items   = res.data.recordsets[0]
            
            if(this.items.length==0)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = 'CLIENTE INESISTENTE.'
              this.msg.type = 1
           
            }         
          }
          else if(res.status==500)
          {
           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1

          } 
          else
          {
           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
          } 
      }).catch(err => 
      {
       
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
          
      }).finally(() => {
        this.bt_spinner = false
      });

      

        

    },
    async export_data()
    {
      
      this.msg.title = ''
      
      this.export_spinner = true
      const sp              = {'sp'       : 'spCustomerListExport'}
      const data            = {'companyId':this.company.Id,'custGroupId':this.custGroupId}
      const json            = Object.assign(data, sp);
      
      
      
      await api.post(json).then(res => {
       
        if(res.status==200)
          {
            let rows  = res.data.recordsets[0]
            
            if(rows.length==0)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = 'CLIENTI NON TROVATI.'
              this.msg.type = 1
              return
           
            }         
            
            this.exportToCSV(rows)

          
          }
          else if(res.status==500)
          {
           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1

          } 
          else
          {
           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
          } 
      }).catch(err => 
      {
       
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
          
      }).finally(() => {
        this.export_spinner = false
      });

      

        

    },
  
    exportToCSV(items)
  {
      
      const header = Object.keys(items[0]);
      let csvContent = "data:text/csv;charset=utf-8," 
      let row = ''
      for (let i = 0; i < header.length; i++) {
          row += header[i] + ";";
      }
      csvContent += row + "\r\n";
      
      items.forEach(item=> 
      {
        row = ''
        for (let i = 0; i < header.length; i++) {
                
                if(header[i].substring(0, 1) == '_')
                {
                
                  row += this.fmt1(item[header[i]]) + ";"
                }
                else
                {
                  row += item[header[i]] + ";"
                }
                

                }
                csvContent += row + "\r\n";
        });
          
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "Clienti.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

   },

 
   
    async setCustomer(item)
    { 
       
       this.items = [] 
       let validSapiaClub
       if(this.company.Id == 1)
       {
        validSapiaClub = await this.getValidSapiaClub(item.customerId) 
        item.SapiaClub = validSapiaClub.stato
       }
       
       
      
       this.$emit('close',item)
            
    }
  
}

}
</script>
<style scoped>

.card-header
{
  /*height      : 45px;*/
  font-family : 'Roboto Condensed' !important;
  font-size   : 20px;
}

.my-custom-scrollbar {
  position: relative;
  height: 400px;
  overflow: auto;
}
.table thead tr:nth-child(1) th
 {
    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   

    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;

    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.form-check-input{
  cursor : pointer
}
.form-check-label{
  cursor : pointer
}

.pointer:hover
{
  background-color : rgb(180, 208, 240);
  color            : black;
  cursor           : pointer;
  font-weight      : bold;
}
.table-wrapper-scroll-y {
  display: block;
}


h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

small{
  font-family: 'Roboto Condensed';
}

.btn_space {  
  justify-content: space-between;  
}
label{
  font-family: 'Roboto Condensed' !important;
  
}
.table th:first-child
{
  border-radius : 0 0 0 0;
}
.table th:last-child
{
  border-radius : 0 0 0 0;  
}


.btn_export
{
  background-color: rgb(186, 212, 44)  !important;
  
  
}



.btn-search
{
  background-color : blueviolet ;
  color            : whitesmoke;
}

.dropdown-menu a:hover
{
  background-color: blue;
  color:white;
}

.custom-control-label
{
  cursor: pointer;
}


.nav.nav-tabs .nav-link.active {
    font-family         : 'Roboto Condensed';
    background-color    : rgb(10, 63, 141);
    color               : white;
    font-style: oblique;
    
}

</style>